import { lazyLogNonStringInput } from '../lazyFunctions';

/**
 * Removes HTML comments **only inside `<style>` tags** so that DOMPurify does not
 * strip the CSS content they wrap, which would break styling.
 * Comments elsewhere in the document are left untouched to avoid un-commenting
 * intentionally deactivated markup.
 *
 * @example
 * removeStyleComments("<style><!--div { color: red }--></style>") returns "<style> div { color: red } </style>"
 */
export function removeStyleComments(htmlString: string): string {
    // To avoid errors when htmlString is not a string, we check if it has the replace function before calling it.
    // If not, we log the usage and return the original input.
    if (typeof htmlString.replace !== 'function') {
        lazyLogNonStringInput.import().then(logNonStringInput => {
            logNonStringInput(
                typeof htmlString,
                !htmlString,
                (htmlString as unknown as object)?.constructor?.name,
                new Error('TrustedTypesNonStringInput').stack
            );
        });
        return htmlString;
    }

    // Match each <style ...>...</style> block and strip only the comment delimiters inside it
    return htmlString.replace(
        /(<style[^>]*>)([\s\S]*?)(<\/style>)/gi,
        (_match, openTag: string, content: string, closeTag: string) =>
            openTag + content.replace(/<!--([\s\S]*?)-->/g, ' $1 ') + closeTag
    );
}
